// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "3cb225f6",
    "hash": "3cb225f6",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3cb225f6",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
